module.exports = __webpack_public_path__ + "img/13.d1f7aa20.jpg";